import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import CompanyDetailForm from '../../components/companyDetailForm';
import { hasPermission } from '../../utilities/helpers';

const CompanyDetail = ({ refreshUser }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { permissions } = useSelector((state) => get(state, 'auth.role'));
  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
  };
  const hasAddPermission = hasPermission(permissions, ['PERM_ADD_COMPANY']);

  return (
    <>
      <div className="team-detail-container">
        <div className="top-section">
          {hasAddPermission && (
            <Button
              type="primary"
              className="login-btn"
              onClick={() => {
                toggleLoginModal();
              }}
            >
              + Add Company
            </Button>
          )}
        </div>

        <CompanyDetailForm refreshUser={refreshUser} edit />

        <Modal
          width="60%"
          className="login-modal"
          destroyOnClose
          closable={false}
          open={showLoginModal}
          onOk={toggleLoginModal}
          onCancel={toggleLoginModal}
          footer={null}
          maskClosable={false}
        >
          <div className="login-container" style={{ boxShadow: 'none' }}>
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleLoginModal();
                }}
              />
              Add Company
            </div>

            <CompanyDetailForm
              refreshUser={refreshUser}
              edit={false}
              toggleLoginModal={toggleLoginModal}
            />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default CompanyDetail;
